export default "__VITE_ASSET__DDMeaCyX__"